// Intent: [Conversion] [Journey]
import React, { useEffect, useState } from "react";
import { LogInIcon } from "lucide-react";
import { useLocation } from "react-router-dom";
import { PORTAL_LOGIN_URL, PORTAL_REGISTER_URL } from "../../config";
function StickyMobileCTA() {
  const {
    pathname
  } = useLocation();
  const [finalCtaVisible, setFinalCtaVisible] = useState(false);
  const [pastHero, setPastHero] = useState(false);
  useEffect(() => {
    const update = () => setPastHero(window.scrollY > Math.min(window.innerHeight * 0.7, 620));
    update();
    window.addEventListener("scroll", update, {
      passive: true
    });
    return () => window.removeEventListener("scroll", update);
  }, []);
  useEffect(() => {
    setFinalCtaVisible(false);
    const target = document.getElementById("final-cta") ?? document.querySelector("footer");
    if (!target || typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(([entry]) => setFinalCtaVisible(entry.isIntersecting), {
      threshold: 0.2
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, [pathname]);
  if (finalCtaVisible || !pastHero) return null;
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-pfpc-navy/15 bg-pfpc-offwhite/95 px-3 pb-[calc(.75rem+env(safe-area-inset-bottom))] pt-3 shadow-[0_-8px_28px_rgba(23,40,59,.12)] backdrop-blur md:hidden" data-id="element-97" data-mp="3fdftfdyn08v4">
      <div className="mx-auto grid max-w-lg grid-cols-[1fr_52px] gap-2" data-id="element-98" data-mp="2rmaer24fnmme">
        <a href={PORTAL_REGISTER_URL} data-analytics="start_design_clicked" className="flex min-h-[48px] items-center justify-center rounded-[10px] bg-pfpc-orange px-4 text-[15px] font-extrabold text-pfpc-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pfpc-navy" data-id="element-99" data-mp="2rodgukiv167h">
          Start Designing
        </a>
        <a href={PORTAL_LOGIN_URL} data-analytics="portal_login_clicked" aria-label="Log in to the ordering portal" className="grid min-h-[48px] place-items-center rounded-[10px] border border-pfpc-navy/25 text-pfpc-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pfpc-orange" data-id="element-100" data-mp="gtfzlbbqo79k">
          <LogInIcon className="h-5 w-5" data-id="element-101" data-mp="1oswtv7br657s" />
        </a>
      </div>
    </div>;
}
export { StickyMobileCTA };